module.exports = __webpack_public_path__ + "static/media/ml.ab19baae.svg";